import React from 'react';
import { Skeleton } from '@mui/material';

export const CheckboxSkeleton = () => <Skeleton
  height={40} width={30}
/>;
export const CheckboxTextSkeleton = () => (
  <Skeleton
    variant='text' width={'100%'}
  />
);
export const BasicSkeleton = (props) => {
  const { height = 10, width = '100%' } = props;

  return <Skeleton
    width={width} height={height}
  />;
};
export const CircleSkeleton = (props) => {
  const { height = 100, width = 100, borderRadius = '50%' } = props;

  return <Skeleton
    sx={{ borderRadius }} width={width} height={height}
  />;
};
